import ar from './ar';
import de from './de';
import eu from './eu';
import gl from './gl';
import it from './it';
import ms from './ms';
import pl from './pl';
import th from './th';
import zh from './zh';
import ca from './ca';
import el from './el';
import fi from './fi';
import id from './id';
import ja from './ja';
import ne from './ne';
import pt from './pt';
import tr from './tr';
import cy from './cy';
import en from './en';
import fr from './fr';
import ko from './ko';
import nl from './nl';
import ru from './ru';
import uk from './uk';
import da from './da';
import es from './es';
import ga from './ga';
import is from './is';
import mn from './mn';
import no from './no';
import sv from './sv';
import vi from './vi';

const Locales = {
	ar,de,eu,gl,it,ms,pl,th,zh,
	ca,el,fi,id,ja,ne,pt,tr,
	cy,en,fr,ko,nl,ru,uk,
	da,es,ga,is,mn,no,sv,vi
};

export default Locales